/**
 * Action types for SSID functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_SSID_LIST = 'GET_SSID_LIST';
export const GET_SSID_LIST_SUCCESS = 'GET_SSID_LIST_SUCCESS';
export const GET_SSID_LIST_FAIL = 'GET_SSID_SCHEDULER_FAIL';
export const DELETE_SSID = 'DELETE_SSID';
export const DELETE_SSID_SUCCESS = 'DELETE_SSID_SUCCESS';
export const DELETE_SSID_FAIL = 'DELETE_SSID_FAIL';
export const OPEN_GLOBAL_SSID_MODAL = 'OPEN_GLOBAL_SSID_MODAL';
export const ADD_SSID = 'ADD_SSID';
export const ADD_SSID_COMPLETE = 'ADD_SSID_COMPLETE';
export const EDIT_SSID = 'EDIT_SSID';
export const EDIT_SSID_COMPLETE = 'EDIT_SSID_COMPLETE';
export const SSID_ADD_TRIGGER = 'SSID_ADD_TRIGGER';
export const RESET_GLOBAL_SSID = 'RESET_GLOBAL_SSID';
export const SHOW_SSID_MODAL = 'SHOW_SSID_MODAL';
